export default "/images/material-icon.svg?79ecb5c33d77c0ca717af823466cfbde";